export type SiteStatus = 'published' | 'unpublished' | 'draft';

const STATUS_LABELS: Record<SiteStatus, string> = {
  published: '公開中',
  unpublished: '非公開',
  draft: '下書き',
};

const STATUS_COLORS: Record<SiteStatus, string> = {
  published: '#1B76D2',
  unpublished: '#FFE0B2 0% 0% no-repeat padding-box',
  draft: '#F7F7F7 0% 0% no-repeat padding-box',
};

export const isStatusPublished = (status?: string): boolean => status === 'published';

export const getStatusLabel = (status?: string): string => {
  if (!status) return '-';
  return STATUS_LABELS[status as SiteStatus] || '-';
};

export const getStatusColor = (status?: string): string => {
  if (!status) return '#9E9E9E';
  return STATUS_COLORS[status as SiteStatus] || '#9E9E9E';
};

